import { embedSearchWidgetPrefix } from '#/modules/embedSearchWidget/routing/embedSearchWidget.paths';
import { searchVolopsPathReference } from '#/modules/search/routing/search.paths';

export const embedSearchWidgetVolopsPrefix =
  embedSearchWidgetPrefix.subprefix('volops');

export const embedSearchWidgetSearchVolopsPath =
  embedSearchWidgetVolopsPrefix.rootPath(
    searchVolopsPathReference.searchParams,
  );

export const embedSearchWidgetViewVolopPath =
  embedSearchWidgetVolopsPrefix.path(':volopId');
